﻿import { IContact } from '../contact';

export interface IEmailSendee {
    id: number;
    emailTemplateId: number;
    emailSendeeFieldValue: number;
    emailAddressFieldString: string;
    centerTypeValue: number;
    centerTypeString: string;
    contactEntityTypeValue: number;
    contactEntityTypeString: string;
    contactPositionIdValue: number;
    contactPositionIdString: string;
    contacts: IContact[];
}
